import { Link } from "react-router-dom";
import "./nav-bar.styles.scss";
import {ReactComponent as Github} from "../../assets/svg/github.svg";
import {ReactComponent as Linkedin} from "../../assets/svg/linkedin.svg";
import {ReactComponent as StackOverflow} from "../../assets/svg/stack-overflow.svg";
// import {ReactComponent as Twitter} from "../../assets/svg/twitter.svg";
import {ReactComponent as Instagram} from "../../assets/svg/instagram.svg";
import {ReactComponent as Home} from "../../assets/svg/home.svg";
import {ReactComponent as About} from "../../assets/svg/About.svg";
import {ReactComponent as Portfolio} from "../../assets/svg/portfolio.svg";
import {ReactComponent as Resume} from "../../assets/svg/Resume.svg";
import {ReactComponent as Email} from "../../assets/svg/envelope.svg";
import  ResumePdf from "../../assets/Abhishek.pdf";
import { linksHandler } from "../../utils/linkhandler";
import Admin  from "../../assets/imgs/admin.jpg";
import { useContext } from "react";
import { ScrollContext } from "../../context/scroll-to";
import { scrollToSection } from "../../utils/scroller";
import { NavContext } from "../../context/nav-context";
const NavBar = () => {
 const {aboutSection, portfolioSection} = useContext(ScrollContext);
 const {isClicked} = useContext(NavContext);
  return (
    <nav className={`nav-bar ${isClicked ? "show" : "hide"} `}>
      <div className="user-info">
        <img
          className="user-img"
          src = {Admin}
          alt = "admin"
        />
        <h2 className="name"> Abhishek </h2>
       {isClicked && <ul className="profiles">
          <Link onClick = {() =>linksHandler("https://github.com/Abhishek7Tech")} className="github">
            <Github className="profilesimg" />
          </Link>
          <Link
            onClick = {() =>linksHandler("https://www.linkedin.com/in/abhishek-lingwal-854858175/")}
            className="linkedin"
          >
              <Linkedin className="profilesimg" />
          </Link>
          <Link
            onClick ={() => linksHandler("https://stackoverflow.com/users/18566426/abhishek-lingwal")}
            className="stack-overflow"
          >
            <StackOverflow className="profilesimg" />
          </Link>
          {/* <Link onClick={() =>linksHandler("https://twitter.com/Abhishek_Tech_")} className="twitter">
            <Twitter className="profilesimg" />
          </Link> */}
          <Link
            onClick = {() => linksHandler("https://www.instagram.com/abhishek.lingwal/")}
            className="instagram"
          >
            <Instagram className="profilesimg" />
          </Link>
        </ul>}
      </div>
      
      {isClicked && <ul className="list">
         <li>
          <Link className="home">
            <div className="linkelements">
            <Home className="listelements" />
            <h3> Home </h3>
            </div>
          </Link>
        </li>
        <li>
          <Link onClick={() =>scrollToSection(aboutSection)}  className="about">
            <div className="linkelements">
            <About className="listelements" />
            <h3> About </h3>
            </div>
          </Link>
        </li>
        <li>
          <Link onClick={()=>scrollToSection(portfolioSection)} className="port">
            <div className="linkelements">
            <Portfolio className="listelements" />
            <h3> Portfolio </h3>
            </div>
          </Link>
        </li>
        <li>
          <a href ={ResumePdf} download rel="noreferrer" className="resume">
           <div className="linkelements">
            <Resume className="listelements" />
            <h3> Resume </h3>
            </div>
          </a>
        </li>
        <li>
          <Link onClick={() => linksHandler("mailto:abhishektab45@gmail.com")} className="e-mail">
            <div className="linkelements">
            <Email className="listelements e-mail"/>
            <h3> Contact </h3>
            </div>
          </Link>
        </li>
      </ul>}
    </nav>
  );
};

export default NavBar;
